export const parseCurrencyValue = (value?: string): number => {
    if (!value) return 0;

    const cleaned = value.replace(/[^\d,.-]/g, '');
    if (!cleaned) return 0;

    const decimalSeparatorIndex = Math.max(cleaned.lastIndexOf(','), cleaned.lastIndexOf('.'));
    if (decimalSeparatorIndex < 0) {
        const whole = Number(cleaned.replace(/[^\d-]/g, ''));
        return Number.isFinite(whole) ? whole : 0;
    }

    const integerPart = cleaned.slice(0, decimalSeparatorIndex).replace(/[.,]/g, '');
    const decimalPart = cleaned.slice(decimalSeparatorIndex + 1).replace(/[^\d]/g, '');
    const normalized = `${integerPart || '0'}.${decimalPart || '0'}`;
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
};
